import { ICONS } from '@frontend/icons';
import { useActiveModal, useModals } from '@frontend/modal';

import { PlatformDetailGrid } from '../../../modal/platform-detail-grid/platform-detail-grid.component';

export interface IotDataModalProps {
    data: { [key: string]: unknown };
}
const IotDataModal = (props: IotDataModalProps) => {
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();
    return (
        <div className='bg-background-surface'>
            <div className='modal-header flex justify-between'>
                <h4>Data</h4>
                <button
                    id='close-button'
                    type='button'
                    className='btn btn-brand-secondary m-0'
                    onClick={() => closeModal(modalId!)}>
                    <ICONS.BUTTON.CLOSE_2 />
                </button>
            </div>
            <div className='modal-body'>
                <PlatformDetailGrid
                    object={props.data}
                    hidden={['id', 'delete_timestamp']}
                />
            </div>
        </div>
    );
};

export default IotDataModal;
